// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.intInput{
    padding: 12px;
    width: 100%;
    border: none;
    appearance: none;
    -webkit-appearance: none;
    border-radius: 5px;
    font-size: 14px;
}

.intInput:focus{
    outline: none;
    border: 1px solid #000;
    box-shadow: 0 0 0 2px rgba(0, 0, 0, 0.1);
}

.intInput:focus-visible{
    outline: none;
    border: 1px solid #000;
    box-shadow: 0 0 0 2px rgba(0, 0, 0, 0.1);
}

.intInput:focus-within{
    outline: none;
    border: 1px solid #000;
    box-shadow: 0 0 0 2px rgba(0, 0, 0, 0.1);
}

.flex-col{
    flex-direction: column;
    gap: 10px;
}`, "",{"version":3,"sources":["webpack://./src/Components/InputFields/Style.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,wBAAwB;IACxB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,wCAAwC;AAC5C;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,wCAAwC;AAC5C;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,wCAAwC;AAC5C;;AAEA;IACI,sBAAsB;IACtB,SAAS;AACb","sourcesContent":[".intInput{\n    padding: 12px;\n    width: 100%;\n    border: none;\n    appearance: none;\n    -webkit-appearance: none;\n    border-radius: 5px;\n    font-size: 14px;\n}\n\n.intInput:focus{\n    outline: none;\n    border: 1px solid #000;\n    box-shadow: 0 0 0 2px rgba(0, 0, 0, 0.1);\n}\n\n.intInput:focus-visible{\n    outline: none;\n    border: 1px solid #000;\n    box-shadow: 0 0 0 2px rgba(0, 0, 0, 0.1);\n}\n\n.intInput:focus-within{\n    outline: none;\n    border: 1px solid #000;\n    box-shadow: 0 0 0 2px rgba(0, 0, 0, 0.1);\n}\n\n.flex-col{\n    flex-direction: column;\n    gap: 10px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
